module.exports = __webpack_public_path__ + "img/amountDepartmentFirst.22e07f62.svg";